// Curated country list for the Organic Rank Tracker. `locationName` is the DataForSEO
// country-level `location_name` (used verbatim as the SERP location, or as the fallback when a
// per-keyword city can't be resolved). United States is the default. This is a common-markets
// subset, not the full DataForSEO list — enough to cover the vast majority of clients while
// keeping the dropdown scannable.
export interface Country { label: string; locationName: string; }

export const COUNTRIES: Country[] = [
  { label: "United States", locationName: "United States" },
  { label: "Canada", locationName: "Canada" },
  { label: "United Kingdom", locationName: "United Kingdom" },
  { label: "Australia", locationName: "Australia" },
  { label: "Ireland", locationName: "Ireland" },
  { label: "New Zealand", locationName: "New Zealand" },
  { label: "India", locationName: "India" },
  { label: "Germany", locationName: "Germany" },
  { label: "France", locationName: "France" },
  { label: "Spain", locationName: "Spain" },
  { label: "Italy", locationName: "Italy" },
  { label: "Netherlands", locationName: "Netherlands" },
  { label: "Belgium", locationName: "Belgium" },
  { label: "Switzerland", locationName: "Switzerland" },
  { label: "Austria", locationName: "Austria" },
  { label: "Sweden", locationName: "Sweden" },
  { label: "Norway", locationName: "Norway" },
  { label: "Denmark", locationName: "Denmark" },
  { label: "Finland", locationName: "Finland" },
  { label: "Portugal", locationName: "Portugal" },
  { label: "Poland", locationName: "Poland" },
  { label: "Mexico", locationName: "Mexico" },
  { label: "Brazil", locationName: "Brazil" },
  { label: "Argentina", locationName: "Argentina" },
  { label: "Chile", locationName: "Chile" },
  { label: "Colombia", locationName: "Colombia" },
  { label: "South Africa", locationName: "South Africa" },
  { label: "United Arab Emirates", locationName: "United Arab Emirates" },
  { label: "Singapore", locationName: "Singapore" },
  { label: "Japan", locationName: "Japan" },
  { label: "Philippines", locationName: "Philippines" },
];

export const DEFAULT_COUNTRY = "United States";
